import { render } from "./BaseExclamationIcon.vue?vue&type=template&id=f1e28698"
const script = {}

import exportComponent from "/Users/maksimzugan/code/nacd-3-family/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__